import _ from '../../core/utils'

const PRINCIPLES_CONFIG = {
    el: _.select( '.section--home-principles .scrollr' ),
    map:  _.select( '.section--home-principles .scrollr img' ),
    principles: {
        wrap: _.select( '.section--home-principles .principles' ),
        items: _.selectAll( '.section--home-principles .principles .principle' )
    }
}

export default PRINCIPLES_CONFIG